<template>
    <div class="view-mapping-list">
        <div v-if="showFlag === 1">
            <tableList
                    :loading="false"
                    :index-show="showIndex"
                    :table-data="tableData"
                    :row-key="rowKey"
                    :table-label="tableLabel" style="margin-top: 20px">
                <template v-slot:oneLevelName="slot">
                    <e-tooltip :content="slot.scope.row.oneLevelName" :set-length="10"/>
                 </template>
                <template v-slot:twoLevelName="slot">
                    <e-tooltip :content="slot.scope.row.twoLevelName" :set-length="10"/>
                 </template>
                <template v-slot:threeLevelName="slot">
                    <e-tooltip :content="slot.scope.row.threeLevelName" :set-length="10"/>
                 </template>
                <template v-slot:categoryName="slot">
                    <e-tooltip :content="slot.scope.row.categoryName" :set-length="10"/>
                 </template>

            </tableList>
            <e-pager style="margin-top: 20px"
                     :page-index="orderPage.pageNum"
                     :total="orderPage.pageTotal"
                     :page-size="orderPage.pageSize"
                     @change="handleCurrentChange"></e-pager>
        </div>
        <div class="flex-column" v-if="showFlag === 2">
            <img src="../../../../../assets/img/order-no-data.png" alt="">
            <div class="no-data-tip">暂无映射列表</div>
        </div>
    </div>
</template>

<script>
    import tableList from "../../../components/common/e-table-list";
    import ePager from "../../../components/common/e-pager";
    import api from '@/modules/projectA/api/purchase';
    import eTooltip from '../../../components/common/e-tooltip.vue';
    export default {
        name: "viewMappingList",
        components: {tableList, ePager,eTooltip},
        data() {
            return {
                isSimple:true,
                orderPage:{
                    pageNum:1,
                    pageSize:10,
                    pageTotal:0,
                },
                showFlag:false,
                tableData: [],
                showIndex: true,
                rowKey: '',
                tableLabel: [
                    {label: "企业一级类目编码", param: "oneLevelCode", align: "center",width:'120'},
                    {label: "企业一级类目名称", param: "oneLevelName", align: "center",slot:'oneLevelName'},
                    {label: "企业二级类目编码", param: "twoLevelCode", align: "center",width:'120'},
                    {label: "企业二级类目名称", param: "twoLevelName", align: "center",slot:'twoLevelName'},
                    {label: "企业三级类目编码", param: "threeLevelCode", align: "center",width:'120'},
                    {label: "企业三级类目名称", param: "threeLevelName", align: "center",slot:'threeLevelName' },
                    {label: "平台类目编码", param: "categoryCode", align: "center",width:'120' },
                    {label: "平台类目名称", param: "categoryName", align: "center",slot:'categoryName'},

                ],
                pageData:{
                    pageNum:1,
                    pageSize:10,
                },
            }
        },
        methods:{
            handleCurrentChange(val){
                this.pageData.pageNum = val;
                this.mdgCategoryPage();
            },
            mdgCategoryPage(){
                api.mdgCategoryPage(this.pageData).then(res => {
                    if (res.success) {
                        this.tableData = res.data.records || [];
                        this.orderPage.pageTotal = res.data.total;
                        if(this.tableData.length === 0){
                            this.showFlag = 2;
                        }else{
                            this.showFlag = 1;
                        }
                    }
                });
            },
        },
        mounted() {
            this.mdgCategoryPage();
        }
    }
</script>

<style scoped lang="scss">
    .view-mapping-list{
        min-height: 402px;
        max-height: 630px;
        background: #FFF;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        padding: 20px;
        img {
            width: 204px;
            height: 160px;
            margin-top: 30px;
            margin-bottom: 20px;
        }
        .no-data-tip {
            font-weight: 500;
            font-size: 16px;
        }
    }

</style>